<template>
  <div>
    <div class="eventInformation">
      <v-container>
        <v-layout>
          <v-flex md8 xs12 class="terms">

            <h3>Waiver and Release Form</h3>

            <p>I, the undersigned, in consideration for my voluntary participation in RTI International’s conference – <strong>{{event}}</strong> on <strong>{{event_date}}</strong>  (“Conference”) - do hereby willfully acknowledge that my signature below attests to my understanding and agreement that:</p>

            <h4>ADMITTANCE</h4>
            <p>In our sole discretion, RESEARCH TRIANGLE INSTITUTE, UNDER THE TRADE NAME RTI INTERNATIONAL (RTI), reserves the right to refuse admittance to or expel from the Conference anyone that we determine is behaving in a manner that could be disruptive to the Conference or any other.</p>

            <h4>REFUND AND CANCELLATION POLICY</h4>
            <p>Conference registration may be cancelled up to thirty (30) calendar days before the Conference date by providing written notice of cancellation to RTI using the instructions on the Conference website. Provided the registered attendee cancels by written notice within the allowable timeframe, RTI will either 1) cancel the invoice, or 2) refund the registration fee to the entity who made payment on behalf of the attendee.</p>

            <p>Attendees who provide written notice of cancellation thirty (30) days or less before the Conference date are not eligible for a refund. If the Conference registration fee has not been received by RTI, the entity responsible for making payment on behalf of the attendee shall be invoiced and payment shall be due. Substitutions of attendees may be made up to seven (7) calendar days before the Conference. Substitutions must be made within the allowable timeframe by providing written notice using the instructions on the Conference website.</p>

            <p>The refund and cancellation policy will not be waived.</p>

            <p>In the event RTI must cancel the Conference due to unforeseen circumstances, RTI will refund the cost of registrations paid. However, RTI does not assume responsibility for any additional costs, charges, or expenses; to include, charges made for travel and lodging.</p>

            <h4>PHOTOGRAPHY, AUDIO AND VIDEO RECORDING</h4>
            <p>We prohibit participants, exhibitors, sponsors, news organizations and other companies from photographing or video or audio-taping some Conference activities. RTI reserves the right to use images taken at the Conference with your photograph and/or likeness in future marketing materials. RTI may edit, alter, copy, exhibit, distribute and publish in print, video, audio recorded productions, and on the World Wide Web material from the Conference for purposes of publicizing RTI programs or other lawful purpose without payment or any other consideration. The photography, audio and video recording will become the property of RTI, stored in a place chosen by RTI and will not be returned to me. In addition, I waive the right to inspect or approve the finished product, including written or electronic copy, wherein my likeness appears. I waive any right to royalties or other compensation arising or related to the use of the photography, audio and video recording.</p>

            <h4>ALCOHOL AND DRUG POLICY</h4>
            <p>Alcohol will not permitted during the Conference. Attendees found possessing or using illicit drugs, as defined by United States federal law, will be required to leave the Conference premises immediately and may be held criminally liable.</p>

            <h4>VALUABLES</h4>
            <p>I am solely responsible for any valuables I decide to bring to the conference. RTI is not responsible for belongings left in rooms, or on premises.</p>

            <h4>LIABILITY</h4>
            <p>I, hereby release, waive liability, discharge, hold harmless, indemnify, and covenant not to sue the RTI for any and all liability incurred in the conduct of, and my participation in, this event.</p>

            <p>I will report any and all injuries to RTI staff immediately. Should any medical emergency arise, I will first call 911.</p>

            <p>RTI executives are the only staff members empowered to grant exceptions to any conference policies or other general RTI practices. I will not liable hold RTI liable for any erroneous statements made by other staff members regarding exceptions to fees or policies.</p>

            <p>NAME: {{name}}<br />

              DATE: {{date}}</p>
            <div v-if="!accepted">
            <v-form ref="termsForm">
            <v-checkbox
              required
              v-model="terms"
              :rules="rules.terms"
            >
              <template slot='label'>By checking this box, you agree to the terms and conditions.<span class='star'>*</span></template>
            </v-checkbox>
            <v-btn
              class='ml-0'
              color="primary"
              @click="submitTerms()"
              v-if="!submitted"
            >Submit</v-btn>
            <v-progress-circular v-else indeterminate />

            </v-form>
            </div>
            <div v-else>
              <h4>Thank you!</h4>
              <p v-if="accepted_date">You accepted the terms and conditions <strong>{{accepted_date |localTime}} ago</strong>.</p>
              <p>Please be on the lookout for more messages from us as we lead up to the event.<br />We are looking forward to having you join us!</p>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: null,
      name: "",
      date: new Date().toLocaleDateString(),
      event: "",
      event_date: "",
      terms: null,
      accepted: false,
      accepted_date: null,
      submitted: false,
      rules: {
        terms: [
          v => !!v || "You must accept the terms and conditions to continue."
        ]
      }
    };
  },
  methods: {
    submitTerms() {
      if (this.$refs.termsForm.validate()) {
        this.submitted = true;
        this.$http
          .put("registration/terms/" + this.user.uuid, { terms: 1 })
          .then(response => {
            this.accepted = true;
            this.accepted_date = response.data.data[0].updated_at;
            this.$store.commit("updateMessage", {
              message: "The terms have been accepted.",
              snackbar: true
            });
          });
      }
    }
  },
  mounted() {
    if (!this.$route.params.uuid) {
    }
    this.$http.get("registration/terms/" + this.$route.params.uuid).then(
      response => {
        this.user = response.data.data[0];
        this.name = this.user.name;
        this.event = this.user.registration.registration_event.name;
        this.event_date = this.user.registration.registration_event.dates;
        if (this.user.terms) {
          this.terms = this.user.terms;
          this.accepted = true;
          this.accepted_date = this.user.updated_at;
        }
        this.$store.commit("updateMessage", {
          message: "Please review the terms and conditions.",
          snackbar: true
        });
      },
      response => {
        this.$store.commit("updateMessage", {
          message:
              "Error: Your information was not found. Please contact support.",
          snackbar: true
        });
        this.$router.push({ path: "/event/missing-token" });
      }
    );
  }
};
</script>
